export const version = "abstract-signer/5.6.1";
//# sourceMappingURL=_version.js.map